import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const BrowserGuideLayer = Loadable({
    loader: () => import(/* webpackChunkName: "BrowserGuideLayer" */ './browserGuideLayer'),
    loading: () => <div />,
});
